import React, { useState } from "react";
import { Link } from "react-router-dom";

import PropTypes from "prop-types";

import "./navbar-b.css";

const NavbarB = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <div className={`navbar-b-thq-navbar-elm ${props.rootClassName} `}>
      <Link to="/" className="navbar-b-navlink">
        <img
          src="/feelers/feelerslogoseachell.webp"
          className="navbar-b-thq-logo-elm"
        />
      </Link>
      <div className="navbar-b-thq-links-container-elm">
        <Link to="/about" className="navbar-b-thq-link-elm1 Navbar-Link">
          About
        </Link>
        <Link to="/archive" className="navbar-b-thq-link-elm2 Navbar-Link">
          Work
        </Link>
        <Link to="/contact" className="navbar-b-thq-link-elm3 Navbar-Link">
          Contact
        </Link>
        <a
          href="https://feelers.bigcartel.com"
          target="_blank"
          rel="noreferrer noopener"
          className="navbar-b-thq-link-elm4 Navbar-Link"
        >
          Shop
        </a>
      </div>
    </div>
  );
};

NavbarB.defaultProps = {
  rootClassName: "",
};

NavbarB.propTypes = {
  rootClassName: PropTypes.string,
};

export default NavbarB;
